export default __webpack_public_path__ + "static/media/customCalendar.247927f3.less";